module.exports = __webpack_public_path__ + "static/img/logo.26c65150.png";